var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import { deprecatedProp as deprecated } from '../utils';
export default class Robot extends PureComponent {
    render() {
        const _a = this.props, { bsStyle, size, alternate, status } = _a, rest = __rest(_a, ["bsStyle", "size", "alternate", "status"]);
        return (React.createElement("div", Object.assign({ className: `robot robot-${size}` }, rest),
            React.createElement("div", { className: "robot-bg" },
                React.createElement(ReactSVG, { path: `https://static.ux.cimpress.io/assets/images/bg_diamond-${status || bsStyle || 'success'}.svg` })),
            React.createElement("div", { className: "robot-figure" },
                React.createElement(ReactSVG, { path: `https://static.ux.cimpress.io/assets/images/robot-${status || bsStyle || 'success'}${alternate ? '-2' : ''}.svg` }))));
    }
}
Robot.propTypes = {
    status: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
    size: PropTypes.oneOf(['sm', 'lg']),
    alternate: PropTypes.bool,
    bsStyle: deprecated(PropTypes.oneOf(['success', 'info', 'warning', 'danger']), 'Use `status` instead.'),
};
Robot.defaultProps = {
    size: 'sm',
};
